
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/discount-tire-success",
      function () {
        return require("private-next-pages/discount-tire-success.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/discount-tire-success"])
      });
    }
  